var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-konsi-solution`]},[_c('MgsP',[_vm._v(_vm._s(_vm.konsi.description))]),_c('MgsP',[_vm._v(_vm._s(_vm.konsi.additional_information))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }